let contentful = require('contentful')

export const client = contentful.createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE,
  accessToken: process.env.REACT_APP_ACCESS_TOKEN
});



// WEBPACK FOOTER //
// ./src/utils/contentful.js